import { useNavigate } from "react-router-dom";
import "./PersonalProjects.css";
import Footer from "../../assets/Footer/Footer";
import Navbar from "../../assets/Navbar/Navbar";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";

function PersonalProjects() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>Personal Projects</h1>
        <p>
          A selection of personal projects where I explored ideas through
          building and experimenting.
        </p>
      </div>

      <div className="line"></div>

      {/* ✅ add class so CSS can override padding on mobile */}
      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>

      <div className="content-lo1">
        <div className="content-lo1-card-container">
          {/* Inventory */}
          <div
            className="card-lo1 card-lo1--inventory"
            onClick={() => navigate("/personal-projects/inventory-management-app")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">Inventory Management App</h3>
          </div>

          {/* PingPong */}
          <div
            className="card-lo1 card-lo1--pingpong"
            onClick={() => navigate("/personal-projects/pingpong-coach-app")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">PingPong Coach App</h3>
          </div>

          {/* 3D Face */}
          <div
            className="card-lo1 card-lo1--facemodel"
            onClick={() => navigate("/personal-projects/facemodel-3d")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">3D Facemodel</h3>
          </div>

          {/* Branding */}
          <div
            className="card-lo1 card-lo1--branding"
            onClick={() => navigate("/personal-projects/branding")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">Branding</h3>
          </div>

          {/* JS Practice */}
          <div
            className="card-lo1 card-lo1--jspractice"
            onClick={() => navigate("/personal-projects/jspractice")}
          >
            <div className="card-lo1-media" />
            <h3 className="card-lo1-title">Javascript Practice</h3>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default PersonalProjects;
